import './Contact.scss'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import Loader from 'react-loaders'
import AnimatedLetter from '../AnimatedLetter/AnimatedLetter'
import emailjs from '@emailjs/browser'
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet'

const Contact = () => {
  useEffect(() => {
    setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 4000)
  }, [])

  const [letterClass, setLetterClass] = useState('text-animate')
  const contactArr = ['C', 'o', 'n', 't', 'a', 'c', 't', ' ', 'm', 'e']

  const refForm = useRef()

  const sendEmail = (event) => {
    event.preventDefault()
    emailjs
      .sendForm(
        'service_0z1hrt4',
        'template_08mn2at',
        refForm.current,
        'na6ERcH1JFEbGaGi4'
      )
      .then(
        () => {
          alert('Message successfully sent!')
          window.location.reload(false)
        },
        () => {
          alert('Failed to send the message, please try again')
        }
      )
  }

  return (
    <Fragment>
      <div className="container contact-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetter
              strArray={contactArr}
              idx={2}
              letterClass={letterClass}
            />
          </h1>
          <p>
            I am highly interested in cooperating with everyone on whatever
            project, especially large and fascinating projects, and it would be
            even better if it was connected to something I am quite familiar
            with. Please do not hesitate to contact me if you have any questions
            or concerns.
          </p>

          <div className="contact-form">
            <form ref={refForm} onSubmit={sendEmail}>
              <ul>
                <li className="half">
                  <input type="text" name="name" placeholder="Name" required />
                </li>
                <li className="half">
                  <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    required
                  />
                </li>
                <li>
                  <input
                    type="text"
                    name="subject"
                    placeholder="Subject"
                    required
                  />
                </li>

                <li>
                  <textarea
                    name="message"
                    placeholder="Message"
                    required
                  ></textarea>
                </li>

                <li>
                  <input type="submit" className="flat-button" value="SEND" />
                </li>
              </ul>
            </form>
          </div>
        </div>

        <div className="info-map">
          <address>
            Cao Nguyễn Minh Quân,
            <br />
            (+84) 79 399 0898
            <br />
            Việt Nam
            <br />
            <strong>Now Live</strong> Thành phố Thủ Đức, Thành phố Hồ Chí Minh,
            70000
            <br />
            <span>
              <em>minhquancn1809@gmail.com</em>
            </span>
          </address>
        </div>

        <div className="map-wrap">
          <MapContainer center={[10.8826, 106.7825]} zoom={14}>
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker position={[10.8826, 106.7825]}>
              <Popup>
                If I am near you, <br />
                please don't hesitate to contact with me!
              </Popup>
            </Marker>
          </MapContainer>
        </div>
      </div>

      <Loader type="pacman" />
    </Fragment>
  )
}

export default Contact
